import { render, staticRenderFns } from "./userPositionMapping.vue?vue&type=template&id=25ed6e60&scoped=true&"
import script from "./userPositionMapping.vue?vue&type=script&lang=js&"
export * from "./userPositionMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed6e60",
  null
  
)

export default component.exports